import { render } from "./TgToolbarItem.vue?vue&type=template&id=4ee5fee1"
import script from "./TgToolbarItem.vue?vue&type=script&lang=js"
export * from "./TgToolbarItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__